import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "com_notice1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "管理者からのお知らせ", -1)
const _hoisted_3 = { class: "date1 roboto" }
const _hoisted_4 = { class: "text1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.infoListData.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoListData, (info) => {
            return (_openBlock(), _createElementBlock("div", {
              key: info.contentId,
              class: "item1"
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(info.postPeriod), 1),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: `/${info.detailPath}/categoryId/${info.categoryId}/contentsId/${info.contentId}`,
                  class: "com_link1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(info.contentsTitle), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}